import { InterestComputationActionDispatch, InterestComputationReduxTypes } from "./types";

export const createInterestComputation= (payload : any):InterestComputationActionDispatch=>({
    type:InterestComputationReduxTypes.INTEREST_COMPUTATION_REPORT,
    payload:payload
})